import React from 'react'

import {
    Grid,
    List,
    ListItemText,
    Typography,
    Stack,
    Link,
} from '@mui/material'
import { Box } from '@mui/system'
import { styled } from '@mui/material/styles'
import { Colors } from '../../styles/theme'
import { FooterTitle } from '../../styles/footer'
import { Link as RouterLink } from 'react-router-dom'
import ObfuscatedEmail from '../ObfuscatedEmail'

// Styled footer link with consistent hover behavior
const FooterLink = styled(Link)(({ theme }) => ({
    color: Colors.beige, // CHANGED: was '#fcf6f0'
    padding: '4px 8px',
    fontSize: 'inherit',
    borderRadius: '4px',
    textDecoration: 'none',
    transition: 'background-color 0.3s ease, color 0.3s ease',

    '&:hover': {
        backgroundColor: Colors.greenLight, // CHANGED: was '#4ebbb4'
        color: Colors.white, // CHANGED: was '#fff'
    },
}))

export default function Footer() {
    return (
        <Box
            sx={{
                background: Colors.shaft,
                color: Colors.white,
                p: { xs: 2, md: 5 },
                mt: 2,
                fontSize: { xs: '13px', md: '14px' },
            }}
        >
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={6}
                    md={3}
                    sx={{
                        justifyContent: { sm: 'center', md: 'flex-Start' },
                    }}
                >
                    <Grid
                        sx={{
                            mt: { xs: 2, sm: 2, md: 0 },
                            ml: { xs: 1, sm: 12, md: 0 },
                        }}
                    >
                        <FooterTitle variant="body1">information</FooterTitle>
                        <List>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        href="/privacy"
                                        underline="none"
                                        aria-label="Read about Privacy Policy"
                                    >
                                        Privacy Policy
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        href="#"
                                        underline="none"
                                        aria-label="Change cookie consent settings"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            if (window.UC_UI)
                                                window.UC_UI.showSecondLayer()
                                        }}
                                    >
                                        Cookie Settings
                                    </FooterLink>
                                </Typography>
                            </ListItemText>

                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        component={RouterLink}
                                        to="/info/terms_conditions"
                                        underline="none"
                                        aria-label="Learn about Terms and Conditions"
                                    >
                                        Terms &amp; Conditions
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                            <ListItemText>
                                <Typography
                                    lineHeight={2}
                                    variant="caption2"
                                    sx={{
                                        pl: 1,
                                        '& a': {
                                            color: Colors.beige,
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            textDecoration: 'none',
                                            transition:
                                                'background-color 0.3s ease, color 0.3s ease',
                                            '&:hover': {
                                                backgroundColor:
                                                    Colors.greenLight,
                                                color: Colors.white,
                                            },
                                        },
                                    }}
                                >
                                    Contact:{' '}
                                    <ObfuscatedEmail color={Colors.beige} />
                                </Typography>
                            </ListItemText>

                            <ListItemText>
                                <Typography
                                    lineHeight={1.6}
                                    variant="caption2"
                                    sx={{ pl: 1 }}
                                >
                                    Call{' '}
                                    <FooterLink
                                        href="tel:+18553233623"
                                        underline="none"
                                        aria-label="Call ElectroBraid at 1-855-323-3623"
                                        sx={{ fontSize: 'inherit' }}
                                    >
                                        1‑855‑EB&nbsp;FENCE
                                    </FooterLink>
                                    <br />
                                    <span
                                        style={{
                                            // fontSize: '0.85em',
                                            opacity: 0.8,
                                            marginLeft: '1.5rem',
                                        }}
                                    >
                                        (1‑855‑323‑3623)
                                    </span>
                                </Typography>
                            </ListItemText>
                        </List>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={6}
                    md={3}
                    sx={{
                        justifyContent: { sm: 'center', md: 'flex-Start' },
                    }}
                >
                    <Grid
                        sx={{
                            mt: { xs: 2, sm: 2, md: 0 },
                            ml: { xs: 1, sm: 12, md: 0 },
                        }}
                    >
                        <FooterTitle variant="body1">Shop</FooterTitle>
                        <List>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        component={RouterLink}
                                        to="/cart"
                                        underline="none"
                                        aria-label="Visit your cart items"
                                    >
                                        Cart Review
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        component={RouterLink}
                                        to="/info/shipping"
                                        underline="none"
                                        aria-label="Learn about Shipping Policies"
                                    >
                                        Shipping Policy
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        component={RouterLink}
                                        to="/info/return_policy"
                                        underline="none"
                                        aria-label="Learn about Return Policy"
                                    >
                                        Return Policy
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                        </List>
                    </Grid>
                </Grid>{' '}
                <Grid
                    item
                    xs={12}
                    md={6}
                    display={'flex'}
                    justifyContent={'center'}
                    sx={{ mt: { xs: 6, sm: 2, md: 0 } }}
                >
                    <Box>
                        <FooterTitle variant="body1">
                            Cardholder Data Security
                        </FooterTitle>
                        <List>
                            <ListItemText>
                                <Typography lineHeight={2} variant="caption2">
                                    <FooterLink
                                        component={RouterLink}
                                        to="/info/card_security"
                                        underline="none"
                                        aria-label="Learn about Cardholder Security Policy"
                                    >
                                        Cardholder Security Policy
                                    </FooterLink>
                                </Typography>
                            </ListItemText>
                        </List>
                        <Stack direction={'row'}>
                            <Box sx={{ mt: { xs: 3, md: 5 } }}>
                                <div className="AuthorizeNetSeal">
                                    <a
                                        href="https://www.authorize.net/"
                                        title="Secure payment acceptance. A Visa Solution"
                                    >
                                        <img
                                            src="/shop/images/secure90x72.png"
                                            alt="Authorize.Net Payment Solution Provider"
                                        />
                                    </a>
                                </div>
                            </Box>

                            <Box sx={{ ml: 9, mt: { xs: 5, md: 7 } }}>
                                <a
                                    href="https://www.foxycart.com/"
                                    title="We chose FoxyCart for easy, SEO ecommerce"
                                >
                                    <img
                                        src="//cdn.foxycart.com/static/images/foxycart_logos/powered-by-foxycart-108x46.png"
                                        alt="Powered by FoxyCart Ecommerce"
                                    />
                                </a>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}
